import type { flightEntity } from 'freedom-shared';

import type { DayObject } from '../types';

/**
 * Extracts unique sorted departure times from offers
 */
function extractUniqueTimes(
  offers: flightEntity.types.MappedOffer[],
  flightIndex: number,
): string[] {
  const times = offers
    .map(offer => offer.flights[flightIndex]?.segments[0]?.dep?.time)
    .filter((time): time is string => !!time);

  return Array.from(new Set(times)).sort();
}

/**
 * Creates day objects for One Way (OW) flights.
 * All departure times are collected together without date grouping.
 */
export function makeDaysOW(
  offers: flightEntity.types.MappedOffer[],
): DayObject[] {
  const times = extractUniqueTimes(offers, 0);

  // For OW, we don't group by date, so we use empty date strings
  // The date won't be displayed in the UI for OW
  return [
    {
      date: '',
      dateFormatted: '',
      times,
    },
  ];
}
